import { AppActions } from 'app/shared/actions/app-actions-interface';

export class WebActions implements AppActions {
  onPrint(): void {}
}
